import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('projects', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`projects/${id}`).then(result => result.data)
  },
  update(projectId, data) {
    return axios.patch(`projects/${projectId}`, data).then(result => result.data)
  },
  store(data) {
    return axios.post('projects', data).then(result => result.data)
  },
  delete(id) {
    return axios.delete(`projects/${id}`).then(result => result.data)
  }
}
